// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38sHw","badges":"styles_badges__3nV5f"};